module.exports = __webpack_public_path__ + "img/photog.e7e4c38e.png";